import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { vendorsLayoutRoute } from '..';

export const vendorsListRoute = createRoute({
  getParentRoute: () => vendorsLayoutRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./VendorsView')),
});
